import React from 'react';
import { packages } from '../data/mock';
import { Button } from '../components/ui/button';
import { Check, Star, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const PackagesPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-cream-50 via-white to-brand-light/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-brand-primary font-semibold text-sm uppercase tracking-wider">
            Pricing
          </span>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold text-gray-900">
            Interior Design <span className="text-brand-primary">Packages</span>
          </h1>
          <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
            Value for every rupee spent. Make your interiors the best with InstaSpaces design, quality and expertise.
          </p>
        </div>
      </section>

      {/* Interior Packages */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-4">
            Home Interior Packages
          </h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            End to end design solutions, from manufacture & design to installation & finishing.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {packages.interior.map((pkg) => (
              <div
                key={pkg.id}
                className={`relative bg-white rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-2xl ${pkg.popular
                  ? 'ring-2 ring-brand-primary shadow-xl scale-105'
                  : 'shadow-lg hover:-translate-y-2'
                  }`}
              >
                {pkg.popular && (
                  <div className="absolute top-0 left-0 right-0 bg-brand-primary text-white text-center py-2 text-sm font-medium">
                    <Star className="w-4 h-4 inline mr-1" />
                    Most Popular
                  </div>
                )}

                <div className={`p-8 ${pkg.popular ? 'pt-14' : ''}`}>
                  <div className="text-center mb-6">
                    <span className="text-gray-500 text-sm">{pkg.name} at</span>
                    <div className="flex items-baseline justify-center mt-2">
                      <span className="text-4xl md:text-5xl font-bold text-brand-primary">{pkg.price}</span>
                      <span className="text-gray-500 ml-1">{pkg.unit}</span>
                    </div>
                    <p className="text-gray-600 mt-3 text-sm italic">"{pkg.tagline}"</p>
                  </div>

                  <ul className="space-y-3 mb-8">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-3">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link to="/contact">
                    <Button
                      className={`w-full py-6 ${pkg.popular
                        ? 'bg-brand-primary hover:bg-brand-dark text-white'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                        }`}
                    >
                      Get Quote
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Construction Packages */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-4">
            Construction Packages
          </h2>
          <p className="text-gray-600 text-center mb-12 max-w-2xl mx-auto">
            Build your dream home with our comprehensive construction packages.
          </p>

          <div className="grid md:grid-cols-3 gap-8">
            {packages.construction.map((pkg) => (
              <div
                key={pkg.id}
                className={`relative bg-white rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-2xl ${pkg.popular
                  ? 'ring-2 ring-brand-primary shadow-xl'
                  : 'shadow-lg hover:-translate-y-2'
                  }`}
              >
                {pkg.popular && (
                  <div className="absolute top-0 left-0 right-0 bg-brand-primary text-white text-center py-2 text-sm font-medium">
                    <Star className="w-4 h-4 inline mr-1" />
                    Recommended
                  </div>
                )}

                <div className={`p-8 ${pkg.popular ? 'pt-14' : ''}`}>
                  <div className="text-center mb-6">
                    <span className="text-lg font-semibold text-gray-900">{pkg.name}</span>
                    <div className="flex items-baseline justify-center mt-2">
                      <span className="text-lg">₹</span>
                      <span className="text-4xl font-bold text-brand-primary">{pkg.price}</span>
                      <span className="text-gray-500 ml-1">{pkg.unit}</span>
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8">
                    {pkg.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-3">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <Link to="/contact">
                    <Button
                      className={`w-full py-6 ${pkg.popular
                        ? 'bg-brand-primary hover:bg-brand-dark text-white'
                        : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                        }`}
                    >
                      Get in Touch
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">
            What's Included in All Packages
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
            {[
              '3D Visualizations',
              'Free Design Consultation',
              '45-Day Installation',
              '10-Year Warranty',
              '146 Quality Checks',
              'Project Manager',
              'Branded Materials',
              'Post-Installation Support'
            ].map((item, index) => (
              <div key={index} className="flex items-center gap-2 justify-center">
                <Check className="w-5 h-5 text-green-500" />
                <span className="text-gray-700">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PackagesPage;
